import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "role_field",
      "id": "role_field"
    },
    model: {
      value: _vm.searchData.field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "field", $$v);
      },
      expression: "searchData.field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "role_name"
    }
  }, [_vm._v(_vm._s(_vm.t('角色')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u8F93\u5165"),
      "data-permission": "role_value",
      "id": "role_value",
      "placeholder": _vm.t('输入')
    },
    model: {
      value: _vm.searchData.value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "value", $$v);
      },
      expression: "searchData.value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u89D2\u8272\u72B6\u6001"),
      "id": "role_status",
      "clearable": "",
      "placeholder": _vm.t('角色状态')
    },
    model: {
      value: _vm.searchData.is_enabled,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "is_enabled", $$v);
      },
      expression: "searchData.is_enabled"
    }
  }, _vm._l(_vm.statusData, function (value, key) {
    return _c('a-select-option', {
      key: key,
      attrs: {
        "value": Number(key)
      }
    }, [_vm._v(_vm._s(_vm.tc(_vm.statusData[key])))]);
  }), 1)], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "role_search",
      "id": "role_search",
      "data-sign": "customer_role_query",
      "ghost": "",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "role_reset",
      "id": "role_reset",
      "data-sign": "customer_role_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mt-15"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', '：')) + " " + _vm._s(_vm.selectedIdList.length) + " "), _c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-sign": "role_list_export_all",
      "id": "role_list_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "id": "role_list_export_select",
      "data-sign": "role_list_export_select",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(" " + _vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "role_disable",
      "id": "role_disable",
      "type": "primary",
      "ghost": "",
      "data-sign": "customer_role_disable",
      "fbu-analyse-name": $t("\u7981\u7528")
    },
    on: {
      "click": _vm.handleDisable
    }
  }, [_vm._v(_vm._s(_vm.t('禁用')))]), _c('a-button', {
    staticClass: "margin-left",
    attrs: {
      "data-permission": "role_enable",
      "id": "role_enable",
      "type": "primary",
      "ghost": "",
      "data-sign": "customer_role_enable",
      "fbu-analyse-name": $t("\u542F\u7528")
    },
    on: {
      "click": _vm.handleEnable
    }
  }, [_vm._v(_vm._s(_vm.t('启用')))]), _c('a-button', {
    staticClass: "margin-left",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "data-permission": "role_add",
      "id": "role_add",
      "type": "primary",
      "data-sign": "customer_role_add",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.t('新增')))])], 1)]), _c('a-skeleton', {
    attrs: {
      "loading": _vm.roleTableLoading,
      "active": ""
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "fixed-header": "",
      "is-filter-box": "",
      "useMouseTool": "",
      "data-sign": "customer_role_list",
      "columns": _vm.columns,
      "row-selection": _vm.rowSelection,
      "data-source": _vm.data,
      "name": "roleList",
      "row-key": "id",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "is_enabled",
      fn: function (ref) {
        var row = ref.row;
        return _c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.tc(_vm.enabledStatus[row.is_enabled])))])]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var row = ref.row;
        return _c('my-operation', {}, [_c('a', {
          staticClass: "mr-10",
          attrs: {
            "data-permission": "role_edit",
            "id": "role_edit",
            "href": "javascript:",
            "data-sign": "customer_role_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(row);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "form"
          }
        }), _vm._v(" " + _vm._s(_vm.t('编辑')) + " ")], 1), _c('a', {
          attrs: {
            "data-permission": "role_permission",
            "id": "role_permission",
            "data-sign": "customer_role_permission_dispatch",
            "href": "javascript:",
            "fbu-analyse-name": $t("\u6743\u9650\u914D\u7F6E")
          },
          on: {
            "click": function ($event) {
              return _vm.handleConfigPermission(row);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "lock"
          }
        }), _vm._v(" " + _vm._s(_vm.t('权限配置')) + " ")], 1)]);
      }
    }])
  })], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "value": _vm.searchData.page_index,
      "isFixed": "",
      "total": _vm.total,
      "name": "roleList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1), _vm.rolePermissionModelVisible ? _c('my-modal', {
    attrs: {
      "title": _vm.t('权限配置'),
      "data-sign": "customer_role_permission_modal",
      "wrap-class-name": "modal-body"
    },
    model: {
      value: _vm.rolePermissionModelVisible,
      callback: function ($$v) {
        _vm.rolePermissionModelVisible = $$v;
      },
      expression: "rolePermissionModelVisible"
    }
  }, [_c('a-form-model', {
    ref: "permissionFormRef",
    attrs: {
      "model": _vm.permissionFormData,
      "data-sign": "customer_role_permission_form",
      "rules": _vm.permissionFormDataRule,
      "layout": "vertical"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#333",
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.t('角色名称')) + _vm._s(_vm.t('common', '：')))]), _c('span', [_vm._v(_vm._s(_vm.permissionFormData.role_name))])]), _c('a-form-model-item', {
    staticClass: "rule-permissionform-model-item-label",
    attrs: {
      "prop": "permission_id_list"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.t('功能节点')) + _vm._s(_vm.t('：')) + " "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "right": "0"
    }
  }, [_c('a-checkbox', {
    model: {
      value: _vm.isViewPermission,
      callback: function ($$v) {
        _vm.isViewPermission = $$v;
      },
      expression: "isViewPermission"
    }
  }, [_vm._v(_vm._s(_vm.t('筛选查看')))])], 1)]), _c('div', {
    staticStyle: {
      "background-color": "#f7f7f5",
      "padding": "15px",
      "border-radius": "10px"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('a-skeleton', {
    attrs: {
      "loading": _vm.permissionListLoading,
      "active": ""
    }
  }, [_c('a-tree', {
    key: "id",
    attrs: {
      "expandedKeys": _vm.expandedKeys,
      "checkedKeys": _vm.permissionFormData.permission_id_list,
      "checkable": "",
      "tree-data": _vm.isViewPermission ? _vm.viewPermissionData.data : _vm.permissionData
    },
    on: {
      "update:expandedKeys": function ($event) {
        _vm.expandedKeys = $event;
      },
      "update:expanded-keys": function ($event) {
        _vm.expandedKeys = $event;
      },
      "check": _vm.handleCheck
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function (scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.title) + " "), scope.desc ? _c('a-popover', {
          attrs: {
            "content": scope.desc
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "question-circle"
          }
        })], 1) : _vm._e()], 1)];
      }
    }], null, false, 2176296250)
  })], 1)], 1), _c('a-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [(_vm.isViewPermission && _vm.viewPermissionData.data && !_vm.viewPermissionData.data.length ? false : true) ? _c('a-button', {
    staticStyle: {
      "padding": "2px !important",
      "position": "absolute",
      "right": "-45px"
    },
    attrs: {
      "type": "link",
      "data-sign": "customer_role_permission_show_all",
      "data-permission": "role_permission_modal_show_all",
      "id": "role_permission_modal_show_all"
    },
    on: {
      "click": function ($event) {
        return _vm.handleExpandedKeys(_vm.isEexpanded ? 'empty' : 'all');
      }
    }
  }, [_vm._v(_vm._s(_vm.isEexpanded ? _vm.t('收起') : _vm.t('展开所有')))]) : _vm._e()], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)])], 1), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('a-button', {
    attrs: {
      "data-permission": "role_permission_modal_cancel",
      "id": "role_permission_modal_cancel",
      "data-sign": "customer_role_permission_modal_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.rolePermissionModelVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.permissionOperate.isAllowEditRolePermission,
      "data-sign": "customer_role_permission_save",
      "data-permission": "role_permission_modal_save",
      "id": "role_permission_modal_save",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleUpdatePermission
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1), _vm.permissionOperate.lockTips ? _c('div', {
    staticClass: "note-desc mt-5"
  }, [_vm._v(_vm._s(_vm.permissionOperate.lockTips))]) : _vm._e()])], 1) : _vm._e(), _c('my-modal', {
    attrs: {
      "data-sign": "customer_role_modal",
      "title": _vm.tc(_vm.operatingStatusText[_vm.roleFormOperatingStatus]) + _vm.t('角色')
    },
    on: {
      "cancel": _vm.handleCancelFormData
    },
    model: {
      value: _vm.roleModalVisible,
      callback: function ($$v) {
        _vm.roleModalVisible = $$v;
      },
      expression: "roleModalVisible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "customer_role_status_form",
      "rules": _vm.roleFormDataRule,
      "model": _vm.formData,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    },
    model: {
      value: _vm.formData,
      callback: function ($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u89D2\u8272\u540D\u79F0"),
      "prop": "role_name",
      "label": _vm.t('角色名称')
    }
  }, [_c('my-input', {
    attrs: {
      "max-length": 20
    },
    model: {
      value: _vm.formData.role_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "role_name", $$v);
      },
      expression: "formData.role_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u72B6\u6001"),
      "prop": "is_enabled",
      "label": _vm.t('状态')
    }
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    model: {
      value: _vm.formData.is_enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "is_enabled", $$v);
      },
      expression: "formData.is_enabled"
    }
  }, _vm._l(_vm.enabledStatus, function (text, key) {
    return _c('a-radio-button', {
      key: key,
      attrs: {
        "value": parseInt(key)
      }
    }, [_vm._v(" " + _vm._s(_vm.tc(text)) + " ")]);
  }), 1)], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('a-button', {
    attrs: {
      "data-permission": "role_customer_role_modal_cancel",
      "id": "role_customer_role_modal_cancel",
      "data-sign": "customer_role_status_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.roleModalVisible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "role_customer_role_modal_save",
      "id": "role_customer_role_modal_save",
      "data-sign": "customer_role_status_save",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleAddOrUpdateRole
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };